import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-chat-response-loader',
  templateUrl: './chat-response-loader.component.html',
  styleUrl: './chat-response-loader.component.scss'
})
export class ChatResponseLoaderComponent {
  @Input() progressStatus?: string;
}